import MainPage from "../pages/MainPage/Main";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard/Main";
import Transactions from "../pages/Transactions/Main";
import Signin from "../pages/Signin/Signin";
import Services from "../pages/Services/Main";
import ApiProviders from "../pages/APIProviders/Main";
import Users from "../pages/Users/Main";
import Alerts from "../pages/Alerts/Main";
import Administrators from "../pages/Administrators/Main";
import Security from "../pages/Security/Main";
import UserList from "../pages/Users/UserList";
import UserTabs from "../pages/Users/UserTabs";
import UserOverview from "../pages/Users/pages/UserOverview";
import UserCommissions from "../pages/Users/pages/UserCommissions";
import UserTransactions from "../pages/Users/pages/UserTransactions";
import IncomingRequests from "../pages/IncomingRequests/Main";
import { getAccessToken } from "../utils/utils";
import Management from "../pages/Management/Main";
import CryptoUsdRate from "../pages/Management/CryptoUsdRate";

const RequireAuth = ({ children }) => {
  return getAccessToken() ? children : <Navigate to="/login" replace />;
};

const Root = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={"/login"} />} />
      <Route path="/login" element={<Signin />} />
      <Route path="/dashboard" element={<RequireAuth><MainPage /></RequireAuth>}>
        <Route path="" element={<Navigate to="/dashboard/overview" />} />
        <Route path="overview" element={<Dashboard />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="services/:slug?" element={<Services />}>
          <Route index path="" />
          <Route path="*" element={<Services />} />
        </Route>
        <Route path="api-providers" element={<ApiProviders />} />
        <Route path="incoming-requests" element={<IncomingRequests />} />
        <Route path="management" element={<Management />} />
        <Route path="withdrawals" element={<Management initialResource="withdrawal-transactions" pageTitle="Withdrawals" />} />
        <Route path="gift-card-transactions" element={<Management initialResource="gift-card-transactions" pageTitle="Gift Card Transactions" />} />
        <Route path="gift-card-rates" element={<Management initialResource="gift-card-rates" pageTitle="Gift Card Rates" />} />
        <Route path="gift-card-services" element={<Management initialResource="gift-card-services" pageTitle="Gift Card Services" />} />
        <Route path="gift-card-units" element={<Management initialResource="gift-card-units" pageTitle="Gift Card Units" />} />
        <Route path="gift-card-subcategories" element={<Management initialResource="gift-card-subcategories" pageTitle="Gift Card Subcategories" />} />
        <Route path="gift-card-batches" element={<Management initialResource="gift-card-batches" pageTitle="Gift Card Batches" />} />
        <Route path="gift-card-codes" element={<Management initialResource="gift-card-codes" pageTitle="Gift Card Codes" />} />
        <Route path="crypto-rates" element={<Management initialResource="crypto-currencies" pageTitle="Crypto Rates" />} />
        <Route path="crypto-networks" element={<Management initialResource="crypto-networks" pageTitle="Crypto Networks" />} />
        <Route path="app-configs" element={<Management initialResource="app-configs" pageTitle="App Configs" />} />
        <Route path="usd-rate" element={<CryptoUsdRate />} />
        <Route path="transaction-limits" element={<Management initialResource="transaction-limits" pageTitle="Transaction Limits" />} />
        <Route path="user-charges" element={<Management initialResource="user-charges" pageTitle="User Charges" />} />
        <Route path="provider-commissions" element={<Management initialResource="provider-commissions" pageTitle="Provider Commissions" />} />
        <Route path="std-commissions" element={<Management initialResource="std-commissions" pageTitle="Standard Commissions" />} />
        <Route path="kyc-reviews" element={<Management initialResource="kyc-reviews" pageTitle="KYC Reviews" />} />
        <Route path="api-logs" element={<Management initialResource="api-logs" pageTitle="API Logs" />} />
        <Route path="notifications" element={<Management initialResource="notifications" pageTitle="Notifications" />} />
        <Route path="marketing-push-notifications" element={<Management initialResource="marketing-push-notifications" pageTitle="Marketing Push" />} />
        {/* <Route path="users" element={<Users />} /> */}

        <Route path="users" element={<Users />}>
          <Route index path="" element={<UserList />} />
          <Route element={<UserTabs />}>
            <Route path=":userId/overview" element={<UserOverview />} />
            <Route path=":userId/commissions" element={<UserCommissions />} />
            <Route path=":userId/transactions" element={<UserTransactions />} />
            <Route path="overview" element={<UserOverview />} />
            <Route path="commissions" element={<UserCommissions />} />
            <Route path="transactions" element={<UserTransactions />} />
          </Route>
        </Route>

        <Route path="alerts" element={<Alerts />} />
        <Route path="administrators" element={<Administrators />} />
        <Route path="security" element={<Security />} />
      </Route>
    </Routes>
  );
};

export default Root;
